.tr {
  position: relative;
  display: flex;
  width: fit-content;
  min-width: 100%;

  &:not(:last-child) {
    border-bottom: var(--ixf-table-border);
  }

  &.isExpanded {
    border-bottom: none;
  }

  &:hover,
  &:focus-within {
    --ixf-table-background-color: var(--ixf-color-neutral-xlt);
  }
}

.subRow {
  display: flex;
  width: fit-content;
  min-width: 100%;
  border-top: var(--ixf-table-border);
  border-bottom: var(--ixf-table-border);
}

.tbody {
  display: block;
}

.rowActionContainer {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 1;

  .rowAction {
    display: flex;
    position: relative;
    height: 100%;
    width: 100%;

    &:focus {
      outline: none;
    }
  }
}
